<template>
  <div v-if="replies && replies.length">
    <h4 ref="titleBar" class="reply-list-title top-line">
      全部回复
    </h4>

    <ul class="comments-list">
      <!-- <AdSlot
        :type="'new'"
        :index="0"
        :list-size="replies.length"
        :total="replyCount"
        :load-status="replyLoadStatus"
      /> -->
      <div>
        <CommentSecondDetailSubReplyV2 key="root_CommentSecondDetailSubReply_v2" :comment-id="commentId" :tree-data="replies" />
      </div>
    </ul>

    <div ref="loadMore" class="load-bar" :style="noContentZoneStyle">
      <div v-if="!isNoContent" class="load-bar-normal">
        <ScrollLoadMore @update:load-more="fetchMoreReplies">
          <div v-if="replyLoadStatus == LoadStatus.LOADING">
            <p class="load-txt load-foot">
              正在加载...
            </p>
          </div>

          <div v-else-if="replyLoadStatus == LoadStatus.LOADCOMPLETED && replies.length && isFirstScreen">
            <p class="load-txt load-foot">
              无更多内容
            </p>
          </div>

          <div v-else-if="replyLoadStatus == LoadStatus.POOR_NETWORK">
            <p class="load-text">
              网络信号差，请重试
            </p>
          </div>

          <div v-else-if="replyLoadStatus == LoadStatus.NO_CONNECTION">
            <DynamicGraph :lottie-json="noConnectionLottie" />
            <p class="load-text">
              无网络连接
            </p>
          </div>

          <div v-else-if="replyLoadStatus == LoadStatus.NO_SERVICE">
            <p class="load-text">
              服务器异常，请上划重试
            </p>
          </div>

          <div v-else-if="replyLoadStatus == LoadStatus.DEFAULT">
            <p class="load-txt load-foot">
              正在加载...
            </p>
          </div>
        </ScrollLoadMore>
      </div>

      <div v-else>
        <div
          v-if="
            replyLoadStatus == LoadStatus.LOADERROR
              || replyLoadStatus == LoadStatus.NO_SERVICE
              || replyLoadStatus == LoadStatus.NO_CONNECTION
              || replyLoadStatus == LoadStatus.POOR_NETWORK
          "
          class="load-bar-nothing"
          @click="fetchMoreReplies"
        >
          <div class="load-retry" />
          <p class="load-txt">
            评论加载失败，点击重试
          </p>
        </div>

        <div
          v-else-if="replyLoadStatus == LoadStatus.LOADING"
          class="sdk-load-loading load-bar-nothing"
        >
          <div class="load-loading-icon" />
          <p class="load-loading-txt">
            正在加载...
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useResizeObserver } from '@vueuse/core'
import { defineComponent, toRefs, onMounted, ref, computed, watch, nextTick } from 'vue';
import { utils, constant } from '@cpc/comment-sdk-common';
import {
  useGlobalState,
  useCacheReplyListInject,
  useSubRepliesList,
} from '@cpc/comment-sdk-core-comment';

import noContent from '../assets/lottie/no-content-light.json?url';
import noContentDark from '../assets/lottie/no-content-dark.json?url';
import loadingError from '../assets/lottie/loading-light.json?url';
import loadingErrorDark from '../assets/lottie/loading-dark.json?url';
import noConnection from '../assets/lottie/no-connection-light.json?url';
import noConnectionDark from '../assets/lottie/no-connection-dark.json?url';
import { useOnCommentClickInject } from '../core/useOnCommentClickProvide/index';
import { commonCommentStat } from '../core/useStat';
import { useBrowserVersion } from '../core/useBrowserVersion';
import avatarDefault from '../assets/img/avatar_default.png';
import avatarDefaultDark from '../assets/img/avatar_default_dark.png';

// import AdSlot from './AdSlot.vue';
// import PraiseButton from "./PraiseButton.vue";
import ScrollLoadMore from './ScrollLoadMore.vue';
import ContentBody from './ContentBody.vue';
import MenuBar from './MenuBar.vue';
import UserProfile from './UserProfile.vue';
import DynamicGraph from './DynamicGraph.vue';
import NoCommentTip from './NoCommentTip.vue';
import CommentSecondDetailSubReply_v2 from './CommentSecondDetailSubReply_v2.vue';

export default defineComponent({
  name: 'CommentSecondDetailReplyV2',

  components: {
    // PraiseButton,
    ScrollLoadMore,
    ContentBody,
    MenuBar,
    UserProfile,
    DynamicGraph,
    NoCommentTip,
    CommentSecondDetailSubReplyV2: CommentSecondDetailSubReply_v2,
    // AdSlot,
  },

  props: {
    commentId: {
      type: String,
      required: true,
      default: '',
    },

    replies: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },

    parentOwner: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },

    replySize: {
      type: Number,
      required: true,
      default: 0,
    },
  },

  setup(props, { emit }) {
    const { translateTimeStamp, query, $ } = utils;
    const { userMeta, documentMeta, isNightMode, pageType } = toRefs(useGlobalState());
    const { LoadStatus } = constant;

    const { commentId, replies, replySize } = toRefs(props);
    const { isBrowserVersionHigherThan } = useBrowserVersion();

    const { fetchMoreReplies, loadStatus: replyLoadStatus } = useSubRepliesList({
      commentId,
      replies,
      replySize,
    });

    const { onCommentClickThrottle } = useOnCommentClickInject();

    const { replyCount } = useCacheReplyListInject();

    const pageElement = ref(null);

    const loadMore = ref(null);

    // 创建ref来存储窗口的可视高度
    const windowHeight = ref(window.innerHeight);

    const isFirstScreen = ref(false);

    onMounted(() => {
      fetchMoreReplies();
      // fetchMoreSubRepliesList();
      // enableUsePreloadList();
      pageElement.value = document.querySelector('#cpc-comment-box');
    });

    const pageElement1 = computed(() => {
      return document.querySelector('#cpc-comment-box')
    });

    useResizeObserver(pageElement1.value, (entries) => {
      const entry = entries[0];
      const { width, height } = entry.contentRect;
      console.log('height', height);
      isFirstScreen.value = height - loadMore.value?.offsetHeight >= windowHeight.value;
    })

    const titleBar = ref(null);

    const isVideoType = computed(() => {
      return parseInt(String(documentMeta.value.styleType)) === 4;
    });

    const noContentZoneStyle = computed(() => {
      const loadBarHeight
        = window.innerHeight
        - (titleBar.value?.offsetHeight || 0)
        - (titleBar.value?.offsetTop || 0);

      return isNoContent.value
        ? {
            // height: Math.max(loadBarHeight, 185) + 'px',
            'display': 'flex',
            'justify-content': 'center',
            'flex-direction': 'column',
          }
        : {};
    });

    const isNoContent = computed(() => {
      return replies.value && replies.value.length === 0;
    });

    const noContentLottie = computed(() => {
      return isNightMode.value ? noContent : noContent;
    });

    const loadingErrorLottie = computed(() => {
      return isNightMode.value ? loadingErrorDark : loadingError;
    });

    const noConnectionLottie = computed(() => {
      return isNightMode.value ? noConnectionDark : noConnection;
    });

    const onErrorAvatarDefault = (event) => {
      event.target.src = isNightMode.value ? avatarDefaultDark : avatarDefault;
    };

    const isFromMsgCenter = computed(() => {
      return query.get('isFromMsgCenter') || false;
    });

    // 判断是否为消息中心的二级页
    const isSecondCommentDetail = computed(() => {
      return pageType.value === 2 && isBrowserVersionHigherThan('8.28') && isFromMsgCenter.value;
    });

    const uid = userMeta.value.uid;
    const directReport = (reply) => {
      commonCommentStat(20084690, {
        userId: reply.owner.id,
      });

      if (uid === reply.owner.id) {
        return;
      }

      onCommentClickThrottle(reply, {
        directReport: true,
      });
    };

    const clickCommentContent = (itemData) => {
      commonCommentStat(20084688);

      // 此处回复当评论使用
      if (isSecondCommentDetail.value) {
        itemData.id = '';
      }

      onCommentClickThrottle(itemData, {
        directComment: true,
      });
    };

    return {
      translateTimeStamp,
      LoadStatus,
      replyLoadStatus,

      // fetchMoreReplies,
      onCommentClickThrottle,

      clickCommentContent,

      noContentLottie,
      loadingErrorLottie,
      noConnectionLottie,

      isFirstScreen,
      loadMore,

      isNoContent,
      noContentZoneStyle,
      isVideoType,
      titleBar,
      onErrorAvatarDefault,
      directReport,
      replyCount,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "../assets/css/common.scss";
@import "../assets/css/loading.scss";
@import "../assets/css/load-bar.scss";
@import "../assets/css/styling-mixin.scss";

.reply-list-title {
  position: relative;
  font-family: ColorFont-Regular, "OPlusSans 3.0";
  font-size: 48px;
  font-weight: 500;
  line-height: 120px;
  padding-top: 24px;
  @include os-browser-styling('', '', false, false, true, true) {
    color: rgba($color: #fff, $alpha: 0.9);
  }
}

.comments-list {
  margin: 0;
  border: 0;
  padding: 0 0 45px 0;
  list-style: none;
}

.load-bar {
  .load-bar-nothing {
    @include os-browser-styling(13, "not-video") {
      margin-top: 66px;
    }
  }
}

// 分割啦

html[data-theme="dark"] {
  .no-network-connection {
    background: url("../assets/img/no-network-connection_dark.png") center center /
      contain no-repeat;
  }
}
</style>
